var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import Axios from 'axios';
import { Injectable, Optional } from '@tanbo/di';
import { HttpConfig } from './http-config';
import { HttpInterceptor } from './http-interceptor';
let Http = class Http {
    constructor(config, interceptor) {
        this.config = config;
        this.interceptor = interceptor;
        this.axiosInstance = Axios.create(this.config);
        if (interceptor) {
            this.axiosInstance.interceptors.request.use(request => {
                var _a;
                return ((_a = interceptor.request) === null || _a === void 0 ? void 0 : _a.call(interceptor, request)) || request;
            });
            this.axiosInstance.interceptors.response.use((response) => {
                var _a;
                return ((_a = interceptor.response) === null || _a === void 0 ? void 0 : _a.call(interceptor, response)) || response.data;
            });
        }
    }
    get(url, params = {}, config) {
        return this.axiosInstance.get(url, Object.assign({ params }, config));
    }
    post(url, data, config) {
        return this.axiosInstance.post(url, data, config);
    }
    put(url, data, config) {
        return this.axiosInstance.put(url, data, config);
    }
    delete(url, params = {}, config) {
        return this.axiosInstance.delete(url, Object.assign({ params }, config));
    }
};
Http = __decorate([
    Injectable(),
    __param(0, Optional()),
    __param(1, Optional()),
    __metadata("design:paramtypes", [HttpConfig,
        HttpInterceptor])
], Http);
export { Http };
